var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "agency-block",
      class: [
        { "agency-block--verified": _vm.offerData.verified },
        "agency-block--status-" + _vm.offerData.status
      ]
    },
    [
      _c(
        "div",
        { staticClass: "agency-block__header" },
        [
          _c("div", { staticClass: "agency-block__header__name" }, [
            _c("span", {
              domProps: { textContent: _vm._s(_vm.translations.title) }
            }),
            _vm._v(" "),
            _c("h2", {
              domProps: { textContent: _vm._s(_vm.offerData.tourOperator) }
            })
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade-transition" } }, [
            _vm.offerData.img
              ? _c("div", { staticClass: "agency-block__header__logo" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.offerData.img,
                      alt: _vm.offerData.tourOperator
                    }
                  })
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "travel-block-grid" },
        [
          _c("travel-block", {
            attrs: {
              title: _vm.translations.travel_out,
              "flight-data": _vm.offerData.outboundFlight
            }
          }),
          _vm._v(" "),
          _c("travel-block", {
            attrs: {
              title: _vm.translations.travel_home,
              "flight-data": _vm.offerData.inboundFlight
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        staticClass: "agency-block__travel-disclaimer",
        domProps: { textContent: _vm._s(_vm.translations.notice) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agency-block__priced-included-wrapper" },
        [
          _c(
            "div",
            { staticClass: "included-item-grid" },
            [
              _vm.offerData.transferInlcuded
                ? _c("included-item", {
                    attrs: {
                      title: _vm.translations.includes.transfer_included,
                      "icon-type": "transfer"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.offerData.transferInlcuded
                ? _c("included-item", {
                    attrs: {
                      title: _vm.translations.includes.transfer_not_included,
                      "icon-type": "transfer"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("included-item", {
                attrs: {
                  title: _vm.translations.includes.loggage_included,
                  "icon-type": "baggage"
                }
              }),
              _vm._v(" "),
              _c("included-item", {
                attrs: {
                  title: _vm.offerData.originalRoomName,
                  translatedTitle: _vm.offerData.translatedRoomName,
                  "room-images": _vm.hasRoomImages,
                  "icon-type": "hotel"
                },
                on: { showroomimages: _vm.onShowRoomImages }
              }),
              _vm._v(" "),
              _c("included-item", {
                attrs: { title: _vm.offerData.boardType, "icon-type": "food" }
              }),
              _vm._v(" "),
              _c("included-item", {
                attrs: {
                  title: _vm.translations.includes.flight_class,
                  "icon-type": "flightclass"
                }
              }),
              _vm._v(" "),
              _vm.offerData.handicap
                ? _c("included-item", {
                    attrs: {
                      title: _vm.translations.includes.handicap,
                      "icon-type": "handicap"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.offerData.handicap
                ? _c("included-item", {
                    attrs: {
                      title: _vm.translations.includes.not_handicap,
                      "icon-type": "noHandicap"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("total-price", {
            attrs: {
              totalPrice: _vm.offerData.totalPrice.value,
              currency: _vm.offerData.totalPrice.currency,
              "show-from": false
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "agency-block__actions" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--travel-description",
            on: { click: _vm.getDescription }
          },
          [
            _c("span", { staticClass: "btn__icon btn__icon--left" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 435.2 405.04"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("span", {
              staticClass: "btn__text",
              domProps: {
                textContent: _vm._s(_vm.translations.travel_description)
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--positive",
            class: { loading: _vm.loadingBooking },
            attrs: { disabled: !_vm.offerCanBeBooked },
            on: { click: _vm.gotoBooking }
          },
          [
            _c("span", { staticClass: "btn__icon btn__icon--left" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 28.08 28.08"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M21.22,2.62l-3,3L3.54,3.33,0,6.86l13,4L7.78,16.06H2.12L0,18.18,7.78,20.3,9.9,28.08,12,26V20.3l5.24-5.23,4,13,3.53-3.53L22.49,9.83l3-3C27.8,4.53,28.75,1.67,27.58.5S23.55.29,21.22,2.62Z"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("span", {
              staticClass: "btn__text",
              domProps: { textContent: _vm._s(_vm.translations.order_btn) }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "btn__icon btn__icon--right" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 27.01 26.01"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"
                    }
                  })
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.openModal
        ? _c(
            "modal",
            {
              staticClass: "modal-view--bg modal-view--tour-description",
              attrs: {
                "close-on-click": true,
                "is-open": _vm.openModal,
                title: _vm.translations.description_title
              },
              on: {
                close: function($event) {
                  _vm.openModal = false
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    slot: "icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 435.2 405.04"
                  },
                  slot: "icon"
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tour-description",
                  class: { loading: _vm.loadingDescription }
                },
                [
                  _c("transition", { attrs: { name: "fade-transition" } }, [
                    _vm.loadingDescription == false
                      ? _c(
                          "div",
                          { staticClass: "tour-description__content" },
                          [
                            !_vm.description
                              ? _c(
                                  "div",
                                  { staticClass: "msg-block msg-block--info" },
                                  [
                                    _c("p", [
                                      _c("b", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.translations.ERRORS
                                              .NO_DESCRIPTION_HEADER
                                          )
                                        }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.translations.ERRORS
                                              .NO_DESCRIPTION_BODY
                                          )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.description
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "msg-block msg-block--flex msg-block--info"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "msg-block__text" },
                                      [
                                        _c("p", [
                                          _c("b", {
                                            domProps: {
                                              textContent: _vm._s(
                                                !_vm.orginalLanguage
                                                  ? _vm.translations
                                                      .translations_info_header
                                                  : _vm.translations
                                                      .translations_info_header_original
                                              )
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations
                                                .translations_info_text
                                            ) + " "
                                          ),
                                          _c("a", {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            domProps: {
                                              textContent: _vm._s(
                                                !_vm.orginalLanguage
                                                  ? _vm.translations
                                                      .translations_info_link
                                                  : _vm.translations
                                                      .translations_info_link_original
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.orginalLanguage = !_vm.orginalLanguage
                                              }
                                            }
                                          })
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "msg-block__action" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "translate-btn",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              title: !_vm.orginalLanguage
                                                ? _vm.translations
                                                    .translations_info_link
                                                : _vm.translations
                                                    .translations_info_link_original
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.orginalLanguage = !_vm.orginalLanguage
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 32 32"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.description
                              ? _c("div", {
                                  staticClass:
                                    "tour-description__content__text",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.description)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.description
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "msg-block msg-block--flex msg-block--info"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "msg-block__text" },
                                      [
                                        _c("p", [
                                          _c("b", {
                                            domProps: {
                                              textContent: _vm._s(
                                                !_vm.orginalLanguage
                                                  ? _vm.translations
                                                      .translations_info_header
                                                  : _vm.translations
                                                      .translations_info_header_original
                                              )
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations
                                                .translations_info_text
                                            ) + " "
                                          ),
                                          _c("a", {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            domProps: {
                                              textContent: _vm._s(
                                                !_vm.orginalLanguage
                                                  ? _vm.translations
                                                      .translations_info_link
                                                  : _vm.translations
                                                      .translations_info_link_original
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.orginalLanguage = !_vm.orginalLanguage
                                              }
                                            }
                                          })
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "msg-block__action" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "translate-btn",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              title: !_vm.orginalLanguage
                                                ? _vm.translations
                                                    .translations_info_link
                                                : _vm.translations
                                                    .translations_info_link_original
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.orginalLanguage = !_vm.orginalLanguage
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 32 32"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"
                                                  }
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingError
        ? _c("div", { staticClass: "msg-block msg-block--error" }, [
            _c("p", [
              _c("b", { domProps: { textContent: _vm._s(_vm.bookingError) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.offerData.status === "XX"
        ? _c("div", { staticClass: "msg-block msg-block--info msg-block-XX" }, [
            _c("p", [
              _c("b", {
                domProps: {
                  textContent: _vm._s(_vm.translations.ERRORS.BO_STATUS.title)
                }
              })
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                textContent: _vm._s(_vm.translations.ERRORS.BO_STATUS.text)
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.offerData.status === "NK" || _vm.offerData.status === "FAIL"
        ? _c(
            "div",
            { staticClass: "msg-block msg-block--error msg-block-NK" },
            [
              _c("p", [
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.ERRORS.NK_STATUS.title)
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  textContent: _vm._s(_vm.translations.ERRORS.NK_STATUS.text)
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.offerData.status === "RQ"
        ? _c(
            "div",
            { staticClass: "msg-block msg-block--warning msg-block-RQ" },
            [
              _c("p", [
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.ERRORS.RQ_STATUS.title)
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  textContent: _vm._s(_vm.translations.ERRORS.RQ_STATUS.text)
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.offerData.status === "FLIGHT_CHANGE"
        ? _c(
            "div",
            {
              staticClass:
                "msg-block msg-block--warning msg-block-FLIGHT_CHANGE"
            },
            [
              _c("p", [
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.ERRORS.FLIGHT_CHANGE)
                  }
                })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.offerData.status === "PRICE_CHANGE"
        ? _c(
            "div",
            {
              staticClass: "msg-block msg-block--warning msg-block-PRICE_CHANGE"
            },
            [
              _c("p", [
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.ERRORS.PRICE_CHANGE)
                  }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21860048", { render: render, staticRenderFns: staticRenderFns })
  }
}